import styled from 'styled-components'
import {
  withBox,
  inputBaseStyles,
  inputBorderStyle,
  InputProps,
} from '@sketch/components'

const StyledTextArea = styled(withBox('textarea'))<InputProps>`
  ${inputBaseStyles};
  ${inputBorderStyle};
  line-height: 1.4;
`

export default StyledTextArea
